import { styled } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  ControlpanelPrimaryButton,
  ControlpanelSecondaryButton,
  ControlpanelSecondaryButtonV2,
  ControlpanelSuccess3thButton,
} from "../../../components/StyledButton";
import DefaultTooltip from "../../../components/DefaultTooltip";
import QuestionIcon16pxSvg from "../../../assets/images/icons/QuestionIcon16pxSvg";
import CustomInput from "../../../components/CustomInput";
import ArrowClockwiseIcon20pxSvg from "../../../assets/images/icons/ArrowClockwiseIcon20pxSvg";
import CheckIcon from "@mui/icons-material/Check";
import { NormalSwitch } from "../../../components/StyledComponents";
import CustomSelect from "../../../components/CustomSelect";
import {
  getListEntitieById,
  getListEntitieByUserId,
  resetSetting,
  updateSetting,
  updateSettingByUser,
} from "../../../axios/Setting/SettingUrlApi";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context/AuthContext";
import ConfirmResetAllDialog from "./ConfirmResetAllDialog";
import CustomTimePicker from "../../../components/CustomTimePickerHaveSecond";
import RefreshCircleIcon20pxSvgV2 from "../../../assets/images/icons/RefreshCircleIcon20pxSvgV2";
import CustomTimePickerHaveSecondV2 from "../../../components/CustomTimePickerHaveSecondV2";

const CustomPrimaryButton = styled(ControlpanelPrimaryButton)(() => ({
  minWidth: "40px",
  ".MuiSvgIcon-root": {
    fontSize: "20px",
  },
}));

const CustomSecondaryButton = styled(ControlpanelSecondaryButtonV2)(() => ({
  minWidth: "40px",
  ".MuiSvgIcon-root": {
    fontSize: "20px",
  },
}));
const ClientTab = ({ tabId, handleRefresh, refreshData }) => {
  const { refreshProfileSetting } = useAuth();
  const [confirmResetAllOpen, setConfirmResetAllOpen] = useState(false);

  const [formData, setFormData] = useState({
    resultDialogTimeout: 0,
    enabledLicensing: false,
    showWorkHoursInClients: false,
    offlineOperations: false,
    manualCaptureStart: false,
    automaticallySynchronizeOfflineData: true,
    offlineDataSynchronizationInterval: 5,
    allowAutomaticPeripheralEnablingOfNewClient: true,
    resetOfflineClientPassword: "admin",
    duplicateEventTimeout: 3,
    eventlogImageSize: "medium",
    allowPredefinedLocation: "always-use-gps",
    selfEnrollTemplates: false,
    hatDetectionFeature: false,
    hatDetectionThreshold: 48,
    guardApplicationSupport: false,
    hideUserListOnClientApps: false,
    multiFaceMode: true,
    cancelEventButtonOnClientEventFeedback: true,
    automaticLeaveApprovalEnabled: false,
    automaticLeaveApprovalTime: "",
    receiveEmailsNotification: false,
    leaveapprovalreasons: ""
  });

  const [settingsData, setSettingsData] = useState([]);
  const { t, i18n } = useTranslation();
  const { profile } = useAuth()

  const settingKeyMap = {
    resultDialogTimeout: "Result dialog timeout ",
    enabledLicensing: "Enable licensing",
    showWorkHoursInClients: "Show work hours in clients",
    offlineOperations: "Offline operations ",
    manualCaptureStart: "Manual capture start",
    automaticallySynchronizeOfflineData: "Automatically synchronize offline data",
    offlineDataSynchronizationInterval: "Offline data synchronization interval",
    allowAutomaticPeripheralEnablingOfNewClient: "Allow automatic peripheral enabling of new clients",
    resetOfflineClientPassword:
      "Reset offline client password",
    duplicateEventTimeout: "Duplicate event timeout",
    eventlogImageSize: "Eventlog image size",
    allowPredefinedLocation: "Allow predefined location ",
    selfEnrollTemplates: "Self enroll templates",
    hatDetectionFeature: "Hat detection feature",
    hatDetectionThreshold: "Hat detection threshold",
    guardApplicationSupport: "Guard application support",
    hideUserListOnClientApps: "Hide user list on windows clients",
    multiFaceMode: "Multi face mode",
    cancelEventButtonOnClientEventFeedback: "Cancel event button on client event feedback ",
    automaticLeaveApprovalTime: "Automatic leave approval time",
    receiveEmailsNotification: "Receive notification emails",
    leaveapprovalreasons: "Default content for leave approval reasons",
    autoApproveLeave: "Auto approve leave",

  };

  useEffect(() => {
    const fetchData = async () => {
      const payload = {
        entityId: tabId,
        userId: profile.userId,
        langId: localStorage.getItem("i18nextLngId"),
      };
      try {
        const { data } = await getListEntitieByUserId(payload);
        const list = data.data;
        setSettingsData(list);
        const mapSettings = Object.fromEntries(
          list.map((item) => [item.settingEntityTypeNameEN, item.value])
        );
        setFormData((prev) => ({
          ...prev,
          resultDialogTimeout: Number(
            mapSettings["Result dialog timeout "] || 0
          ),
          enabledLicensing:
            mapSettings["Enable licensing"] === "0" ? false : true,
          showWorkHoursInClients:
            mapSettings["Show work hours in clients"] === "0" ? false : true,
          offlineOperations:
            mapSettings["Offline operations "] === "0" ? false : true,
          manualCaptureStart:
            mapSettings["Manual capture start"] === "0" ? false : true,
          automaticallySynchronizeOfflineData:
            mapSettings["Automatically synchronize offline data"] === "0"
              ? false
              : true,
          offlineDataSynchronizationInterval:
            mapSettings["Offline data synchronization interval"] || "",
          allowAutomaticPeripheralEnablingOfNewClient:
            mapSettings[
              "Allow automatic peripheral enabling of new clients"
            ] === "0"
              ? false
              : true,
          resetOfflineClientPassword:
            mapSettings["Reset offline client password"] || "",
          duplicateEventTimeout: Number(
            mapSettings["Duplicate event timeout"] || 0
          ),
          eventlogImageSize: mapSettings["Eventlog image size"] || "",
          allowPredefinedLocation:
            mapSettings["Allow predefined location "] || "",
          selfEnrollTemplates:
            mapSettings["Self enroll templates"] === "0" ? false : true,
          hatDetectionFeature: Number(
            mapSettings["Hat detection feature"] || 0
          ),
          hatDetectionThreshold: Number(
            mapSettings["Hat detection threshold"] || 0
          ),
          guardApplicationSupport:
            mapSettings["Guard application support"] === "0" ? false : true,
          hideUserListOnClientApps:
            mapSettings["Hide user list on windows clients"] === "0"
              ? false
              : true,
          multiFaceMode: mapSettings["Multi face mode"] === "0" ? false : true,
          cancelEventButtonOnClientEventFeedback:
            mapSettings["Cancel event button on client event feedback "] === "0"
              ? false
              : true,
          receiveEmailsNotification:
            mapSettings["Receive notification emails"] === "0"
              ? false
              : true,
          automaticLeaveApprovalEnabled:
            !!mapSettings["Automatic leave approval time"]
          ,
          automaticLeaveApprovalTime:
            mapSettings["Automatic leave approval time"] || "",
          leaveapprovalreasons:
            mapSettings["Default content for leave approval reasons"] || "",
          autoApproveLeave:
            mapSettings["Auto approve leave"] === "0"
              ? false
              : true,
        }));
      } catch (error) {
        if (error.response) {
          if (error.response.status !== 401) {
            toast.error(t(error?.response.data));
          }
        } else {
          toast.error(t('common.network-timeout'));
        }
      }
    };
    if (tabId) {
      fetchData();
    }
  }, [tabId, refreshData]);

  const getSettingItem = (typeName) => {
    if (!typeName) return null;
    const exact = settingsData.find(
      (item) => item.settingEntityTypeNameEN === typeName
    );
    if (exact) return exact;

    // Fallback: trim + ignore case (tránh lệch tên setting từ BE)
    const normalized = String(typeName).trim().toLowerCase();
    return (
      settingsData.find(
        (item) =>
          String(item.settingEntityTypeNameEN || "")
            .trim()
            .toLowerCase() === normalized
      ) || null
    );
  };

  const getAttrTypeId = (typeName) => {
    const item = getSettingItem(typeName);
    return item ? item.entityAttrTypeId : null;
  };

  // Lấy tiêu đề setting theo ngôn ngữ UI (EN/VN từ API), fallback i18n
  const getSettingTitle = useCallback((typeNameEN, fallbackKey) => {
    const item = getSettingItem(typeNameEN);
    const isVi = String(i18n.language || "").toLowerCase().startsWith("vi");
    if (item) {
      const label = isVi
        ? (item.settingEntityTypeNameVN || item.settingEntityTypeNameEN)
        : item.settingEntityTypeNameEN;
      if (label) return label;
    }
    return fallbackKey ? t(fallbackKey) : (typeNameEN || "");
  }, [settingsData, i18n.language, t]);

  // Tiêu đề section từ settingEntityNameEN/VN của một setting đại diện
  const getSettingEntityTitle = useCallback((typeNameEN, fallbackKey) => {
    const item = getSettingItem(typeNameEN);
    const isVi = String(i18n.language || "").toLowerCase().startsWith("vi");
    if (item) {
      const label = isVi
        ? (item.settingEntityNameVN || item.settingEntityNameEN)
        : item.settingEntityNameEN;
      if (label) return label;
    }
    return fallbackKey ? t(fallbackKey) : "";
  }, [settingsData, i18n.language, t]);

  const handleAutoSave = async (settingKey, value) => {
    const entityAttrTypeId = getAttrTypeId(settingKey);
    if (!entityAttrTypeId) {
      console.warn(`No entityAttrTypeId found for ${settingKey}`);
      return;
    }

    let contentUpdate = value;
    const keyName = Object.keys(settingKeyMap).find(
      (k) => settingKeyMap[k] === settingKey
    );

    // Fix for booleans: true -> "1", false -> "0" (corrected from original bug)
    if (
      keyName === "enabledLicensing" ||
      keyName === "showWorkHoursInClients" ||
      keyName === "offlineOperations" ||
      keyName === "manualCaptureStart" ||
      keyName === "automaticallySynchronizeOfflineData" ||
      keyName === "allowAutomaticPeripheralEnablingOfNewClient" ||
      keyName === "selfEnrollTemplates" ||
      keyName === "guardApplicationSupport" ||
      keyName === "hideUserListOnClientApps" ||
      keyName === "multiFaceMode" ||
      keyName === "cancelEventButtonOnClientEventFeedback" ||
      keyName === "automaticLeaveApprovalEnabled" ||
      keyName === "receiveEmailsNotification" ||
      keyName === "autoApproveLeave"
    ) {
      contentUpdate = value ? "1" : "0";
    }

    const payload = {
      userId: profile.userId,
      entityId: 3,
      entityAttributeTypeId: entityAttrTypeId,
      value: contentUpdate,
      langId: localStorage.getItem("i18nextLngId"),
    };

    try {
      const response = await updateSettingByUser(payload);
      if (response?.data?.responseCode === 0) {
        toast.success(t("common.update-setting-successfully"));
        handleRefresh();
        refreshProfileSetting();
      } else {
        toast.error(response?.data?.message);
        // Optional: Revert state on error (requires storing old value)
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t('common.network-timeout'));
      }
      // Optional: Revert
    }
  };

  const debounceRef = useRef(null);

  const debouncedAutoSave = (settingKey, value) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      handleAutoSave(settingKey, value);
    }, 700);
  };

  const handleInputChange = (e) => {
    const { name, checked, type } = e.target;
    const value = type === "checkbox" ? checked : e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    const settingKey = settingKeyMap[name];
    if (settingKey) {
      debouncedAutoSave(settingKey, value);
    }
  };

  const handleDataChange = (name, newData) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: newData,
    }));
  };

  const eventlogImageSizeData = [
    { value: "Small", label: t("common.small") },
    { value: "Medium", label: t("common.medium") },
    { value: "Original", label: t("common.original") },
  ];

  const allowPredefinedLocationData = [
    { value: "Always use GPS", label: t("common.alwaysUseGPS") },
    {
      value: "Prefer GPS over predefined",
      label: t("common.preferGPSOverPredefined"),
    },
    { value: "Always use predefined", label: t("common.alwaysUsePredefined") },
  ];

  const handleSaveSettings = async (entityAttrTypeId, keyName) => {
    let contentUpdate;

    switch (keyName) {
      case "enabledLicensing":
      case "showWorkHoursInClients":
      case "offlineOperations":
      case "manualCaptureStart":
      case "automaticallySynchronizeOfflineData":
      case "allowAutomaticPeripheralEnablingOfNewClient":
      case "selfEnrollTemplates":
      case "guardApplicationSupport":
      case "hideUserListOnClientApps":
      case "multiFaceMode":
      case "cancelEventButtonOnClientEventFeedback":
      case "receiveEmailsNotification":
        contentUpdate = formData[keyName] ? "0" : "1";
        break;

      case "resultDialogTimeout":
      case "offlineDataSynchronizationInterval":
      case "resetOfflineClientPassword":
      case "duplicateEventTimeout":
      case "eventlogImageSize":
      case "allowPredefinedLocation":
      case "hatDetectionFeature":
      case "hatDetectionThreshold":
      case "automaticLeaveApprovalTime":
      case "leaveapprovalreasons":
        contentUpdate = formData[keyName];
        break;

      default:
        contentUpdate = null;
    }

    const payload = {
      userId: profile.userId,
      entityId: 3,
      entityAttributeTypeId: entityAttrTypeId,
      value: contentUpdate,
      langId: localStorage.getItem("i18nextLngId"),
    };
    try {
      const response = await updateSettingByUser(payload);
      if (response?.data?.responseCode === 0) {
        toast.success(t("common.update-setting-successfully"));
        handleRefresh();
        refreshProfileSetting();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t('common.network-timeout'));
      }
    }
  };

  const handleResetSetting = async (entityAttrTypeId) => {
    const payload = {
      entityId: tabId,
      entityAttributeTypeId: entityAttrTypeId,
      langId: localStorage.getItem("i18nextLngId"),
    };
    try {
      const response = await resetSetting(payload);
      if (response?.data?.responseCode === 0) {
        toast.success(t("common.reset-setting-successfully"));
        handleRefresh();
        refreshProfileSetting();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t('common.network-timeout'));
      }
    }
  };

  const handleResetAll = async () => {
    setConfirmResetAllOpen(false);
    const promises = settingsData.map(async (item) => {
      const payload = {
        entityId: tabId,
        entityAttributeTypeId: item.entityAttrTypeId,
        langId: localStorage.getItem("i18nextLngId"),
      };
      return resetSetting(payload);
    });

    try {
      const responses = await Promise.all(promises);
      const allSuccessful = responses.every((r) => r?.data?.responseCode === 0);
      if (allSuccessful) {
        toast.success(t("common.reset-setting-successfully"));
        handleRefresh();
        refreshProfileSetting();
      } else {
        toast.error("Some settings failed to reset");
      }
    } catch (error) {
      toast.error("Failed to reset all settings");
    }
  };

  const handleCloseConfirmResetAll = () => {
    setConfirmResetAllOpen(false);
  };

  const handleOpenConfirmResetAll = () => {
    setConfirmResetAllOpen(true);
  };

  return (
    <>
      <div className="client-tab flex flex-col ">
        <div className="flex justify-end pt-3 pointer-events-auto mb-3">
          <ControlpanelSuccess3thButton onClick={handleOpenConfirmResetAll} sx={{
              pointerEvents: "auto",
              opacity: 0.5,
              pointerEvents: "none",
            }}>
            <div className="flex gap-2"><RefreshCircleIcon20pxSvgV2 className="text-[#0057FF]"></RefreshCircleIcon20pxSvgV2>
              <p>{t("button.reset-all-to-default")}</p></div>
          </ControlpanelSuccess3thButton>
        </div>
        <div>
          <div className="
            grid
            2xl:grid-cols-2
            grid-cols-1
            gap-0
            items-stretch
          ">
            <div className="2xl:pr-2 flex">
              <div className='bg-[#F9FAFB] p-4 rounded-[16px] space-y-2 w-full h-full' data-tour="setting-client-leave">
                <h2 className='font-semibold'>{getSettingEntityTitle("Automatic leave approval time", "common.leave")}</h2>

                <div className="flex items-center justify-between py-2 gap-6">
                  {/* LEFT: Label + Tooltip */}
                  <div className="flex items-center gap-2">
                    <p>{getSettingTitle("Automatic leave approval time", "common.automatic-leave-approval-time")}</p>
                    <DefaultTooltip
                      title={getSettingTitle("Automatic leave approval time", "common.automatic-leave-approval-time")}
                      readMore={false}
                      content={
                        <div className="flex flex-col gap-3">
                          <p>{t("common.general-setting-question-56")}.</p>
                        </div>
                      }
                    >
                      <div>
                        <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                      </div>
                    </DefaultTooltip>
                  </div>

                  {/* RIGHT: Enable + Switch + Reset */}
                  <div className="flex items-center gap-4 shrink-0">


                    <NormalSwitch
                      name="autoApproveLeave"
                      checked={formData.autoApproveLeave}
                      onChange={(e) => {
                        const { checked } = e.target;

                        setFormData((prev) => ({
                          ...prev,
                          autoApproveLeave: checked,
                        }));

                        // autosave
                        debouncedAutoSave(
                          "Auto approve leave",
                          checked
                        );
                      }}
                    />


                    <CustomSecondaryButton
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        // 1️⃣ Update UI ngay
                        setFormData((prev) => ({
                          ...prev,
                          automaticLeaveApprovalEnabled: false,
                        }));

                        // 2️⃣ Autosave value = 0
                        debouncedAutoSave(
                          "Allow automatic approval of leave requests",
                          false
                        );
                      }}
                    >
                      <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                    </CustomSecondaryButton>

                  </div>
                </div>

                {formData.autoApproveLeave && (
                  <div className="pl-4 flex items-center gap-3">
                    <div className="flex-1">
                      <CustomTimePickerHaveSecondV2
                        hoursLabel={false}
                        secondsEnabled={false}
                        maxHours={23}
                        name="automaticLeaveApprovalTime"
                        value={formData.automaticLeaveApprovalTime || ""}
                        onTimeChange={(value) => {
                          handleDataChange("automaticLeaveApprovalTime", value);

                          debouncedAutoSave(
                            settingKeyMap.automaticLeaveApprovalTime,
                            value
                          );
                        }}
                        className="w-full"
                      />
                    </div>

                    <CustomSecondaryButton
                      onClick={() =>
                        handleResetSetting(
                          getAttrTypeId("Automatic leave approval time"),
                          "automaticLeaveApprovalTime"
                        )
                      }
                    >
                      <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                    </CustomSecondaryButton>
                  </div>
                )}

                <div className="space-y-1">
                  {/* Label */}
                  <div className="flex items-center gap-2">
                    <p>{getSettingTitle("Default content for leave approval reasons", "common.default-content-for-leave-approval-reasons")}</p>
                    <DefaultTooltip
                      title={getSettingTitle("Default content for leave approval reasons", "common.default-content-for-leave-approval-reasons")}
                      readMore={false}
                      content={
                        <div className="flex flex-col gap-3">
                          <p>{t("common.general-setting-question-55")}.</p>
                        </div>
                      }
                    >
                      <div>
                        <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                      </div>
                    </DefaultTooltip>
                  </div>

                  {/* Control */}
                  <div className="flex items-center gap-3">
                    <div className="flex-1">
                      <CustomInput
                        name="leaveapprovalreasons"
                        value={formData.leaveapprovalreasons}
                        handleInputChange={handleInputChange}
                        inputType="text"
                        className="w-full"
                        readOnly={false}
                        minValue={0}
                        labelEnable={false}
                      />
                    </div>

                    <CustomSecondaryButton
                      onClick={() =>
                        handleResetSetting(
                          getAttrTypeId("Default content for leave approval reasons"),
                          "leaveapprovalreasons"
                        )
                      }
                    >
                      <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                    </CustomSecondaryButton>
                  </div>
                </div>
              </div>
            </div>
            <div className="2xl:pl-2 flex">
              <div className='bg-[#F9FAFB] p-4 rounded-[16px] space-y-2 w-full h-full' data-tour="setting-client-notification">
                <h2 className='font-semibold'>{getSettingEntityTitle("Receive notification emails", "common.notifications")}</h2>

                <div className="flex items-center justify-between py-2 gap-6">
                  {/* LEFT: Label + Tooltip */}
                  <div className="flex items-center gap-2">
                    <p>{getSettingTitle("Receive notification emails", "common.receive-notifications-email")}</p>
                    <DefaultTooltip
                      title={getSettingTitle("Receive notification emails", "common.receive-notifications-email")}
                      readMore={false}
                      content={
                        <div className="flex flex-col gap-3">
                          <p>{t("common.general-setting-question-54")}.</p>
                        </div>
                      }
                    >
                      <div>
                        <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                      </div>
                    </DefaultTooltip>
                  </div>

                  {/* RIGHT: Enable + Switch + Reset */}
                  <div className="flex items-center gap-4 shrink-0">


                    <NormalSwitch
                      name="receiveEmailsNotification"
                      checked={!!formData.receiveEmailsNotification}
                      onChange={(e) => {
                        const { checked } = e.target;
                        handleInputChange(e);
                      }}
                    />

                    <CustomSecondaryButton
                      onClick={() =>
                        handleResetSetting(
                          getAttrTypeId("Receive notification emails"),
                          "receiveEmailsNotification"
                        )
                      }
                    >
                      <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                    </CustomSecondaryButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="
  bg-[#F9FAFB] p-4 rounded-[16px] space-y-2 mt-4
">
          <div>
            <h2 className='font-semibold'>Mobile & Web</h2>
          </div>
          <div className="
              grid
              2xl:grid-cols-2
              grid-cols-1
              gap-0
              bg-[#F9FAFB] rounded-[16px] space-y-2 mt-4
            ">
            <div className="2xl:pr-6">
              <div className="py-2 space-y-1">
                {/* Label */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Result dialog timeout ", "common.result-dialog-timeout")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Result dialog timeout ", "common.result-dialog-timeout")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-14")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* Control */}
                <div className="flex items-center gap-3">
                  <div className="flex-1">
                    <CustomInput
                      name="resultDialogTimeout"
                      value={formData.resultDialogTimeout}
                      handleInputChange={handleInputChange}
                      inputType="number"
                      className="w-full"
                      readOnly={true}
                      minValue={0}
                      labelEnable={false}
                    />
                  </div>

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(getAttrTypeId("Result dialog timeout "))
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="py-2 space-y-1">
                {/* Label */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Offline data synchronization interval", "common.offline-data-synchronization-interval")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Offline data synchronization interval", "common.offline-data-synchronization-interval")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-20")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* Control */}
                <div className="flex items-center gap-3">
                  <div className="flex-1">
                    <CustomInput
                      name="offlineDataSynchronizationInterval"
                      value={formData.offlineDataSynchronizationInterval}
                      handleInputChange={handleInputChange}
                      inputType="number"
                      className="w-full"
                      readOnly={true}
                      minValue={0}
                      maxValue={59}
                      labelEnable={false}
                    />
                  </div>

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Offline data synchronization interval"),
                        "offlineDataSynchronizationInterval"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="py-2 space-y-1">
                {/* Label */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Reset offline client password", "common.reset-offine-client-password")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Reset offline client password", "common.reset-offine-client-password")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-22")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* Control */}
                <div className="flex items-center gap-3">
                  <div className="flex-1">
                    <CustomInput
                      name="resetOfflineClientPassword"
                      value={formData.resetOfflineClientPassword}
                      handleInputChange={handleInputChange}
                      inputType="text"
                      className="w-full"
                      readOnly={true}
                      labelEnable={false}
                    />
                  </div>

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Reset offline client password"),
                        "resetOfflineClientPassword"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="py-2 space-y-1">
                {/* Label */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Duplicate event timeout", "common.duplicate-event-timeout")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Duplicate event timeout", "common.duplicate-event-timeout")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-23")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* Control */}
                <div className="flex items-center gap-3">
                  <div className="flex-1">
                    <CustomInput
                      name="duplicateEventTimeout"
                      value={formData.duplicateEventTimeout}
                      handleInputChange={handleInputChange}
                      inputType="number"
                      className="w-full"
                      readOnly={true}
                      minValue={0}
                      labelEnable={false}
                    />
                  </div>

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Duplicate event timeout"),
                        "duplicateEventTimeout"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="py-2 space-y-1">
                {/* Label */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Eventlog image size", "common.eventlog-image-size")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Eventlog image size", "common.eventlog-image-size")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-24")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* Control */}
                <div className="flex items-center gap-3">
                  <div className="flex-1">
                    <CustomSelect
                      name="eventlogImageSize"
                      value={formData.eventlogImageSize}
                      onChange={handleInputChange}
                      options={eventlogImageSizeData}
                      className="w-full"
                      readOnly={true}
                    />
                  </div>

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Eventlog image size"),
                        "eventlogImageSize"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="py-2 space-y-1">
                {/* Label */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Allow predefined location ", "common.allow-predefined-location")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Allow predefined location ", "common.allow-predefined-location")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-25")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* Control */}
                <div className="flex items-center gap-3">
                  <div className="flex-1">
                    <CustomSelect
                      name="allowPredefinedLocation"
                      value={formData.allowPredefinedLocation}
                      onChange={handleInputChange}
                      options={allowPredefinedLocationData}
                      className="w-full"
                      readOnly={true}
                    />
                  </div>

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Allow predefined location "),
                        "allowPredefinedLocation"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="py-2 space-y-1">
                {/* Label */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Hat detection feature", "common.hat-detection-feature")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Hat detection feature", "common.hat-detection-feature")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-27")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* Control */}
                <div className="flex items-center gap-3">
                  <div className="flex-1">
                    <CustomInput
                      name="hatDetectionFeature"
                      value={formData.hatDetectionFeature}
                      handleInputChange={handleInputChange}
                      inputType="number"
                      className="w-full"
                      readOnly={true}
                      minValue={0}
                      labelEnable={false}
                    />
                  </div>

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Hat detection feature"),
                        "hatDetectionFeature"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="py-2 space-y-1">
                {/* Label */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Hat detection threshold", "common.hat-detection-threshold")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Hat detection threshold", "common.hat-detection-threshold")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-28")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* Control */}
                <div className="flex items-center gap-3">
                  <div className="flex-1">
                    <CustomInput
                      name="hatDetectionThreshold"
                      value={formData.hatDetectionThreshold}
                      handleInputChange={handleInputChange}
                      inputType="number"
                      className="w-full"
                      readOnly={true}
                      minValue={0}
                      labelEnable={false}
                    />
                  </div>

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Hat detection threshold"),
                        "hatDetectionThreshold"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

            </div>
            <div className="2xl:pl-6">
              <div className="flex items-center justify-between py-2 gap-6">
                {/* LEFT: Label + Tooltip */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Enable licensing", "common.enable-licensing")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Enable licensing", "common.enable-licensing")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-15")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* RIGHT: Enable + Switch + Reset */}
                <div className="flex items-center gap-4 shrink-0">


                  <NormalSwitch
                    disabled={true}
                    name="enabledLicensing"
                    checked={formData.enabledLicensing}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                  />

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Enable licensing"),
                        "enabledLicensing"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="flex items-center justify-between py-2 gap-6">
                {/* LEFT: Label + Tooltip */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Show work hours in clients", "common.show-work-hours-in-clients")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Show work hours in clients", "common.show-work-hours-in-clients")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-16")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* RIGHT: Enable + Switch + Reset */}
                <div className="flex items-center gap-4 shrink-0">


                  <NormalSwitch
                    disabled={true}
                    name="showWorkHoursInClients"
                    checked={formData.showWorkHoursInClients}
                    // onChange={handleInputChange}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                  />

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Show work hours in clients"),
                        "showWorkHoursInClients"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="flex items-center justify-between py-2 gap-6">
                {/* LEFT: Label + Tooltip */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Offline operations ", "common.offline-operations")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Offline operations ", "common.offline-operations")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-17")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* RIGHT: Enable + Switch + Reset */}
                <div className="flex items-center gap-4 shrink-0">

                  <NormalSwitch
                    disabled={true}
                    name="offlineOperations"
                    checked={formData.offlineOperations}
                    // onChange={handleInputChange}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                  />

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Offline operations "),
                        "offlineOperations"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="flex items-center justify-between py-2 gap-6">
                {/* LEFT: Label + Tooltip */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Manual capture start", "common.manual-capture-start")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Manual capture start", "common.manual-capture-start")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-18")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* RIGHT: Enable + Switch + Reset */}
                <div className="flex items-center gap-4 shrink-0">


                  <NormalSwitch
                    name="manualCaptureStart"
                    checked={formData.manualCaptureStart}
                    // onChange={handleInputChange}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                    disabled={true}
                  />

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Manual capture start"),
                        "manualCaptureStart"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="flex items-center justify-between py-2 gap-6">
                {/* LEFT: Label + Tooltip */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Automatically synchronize offline data", "common.automatically-synchronize-offline-data")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Automatically synchronize offline data", "common.automatically-synchronize-offline-data")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-19")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* RIGHT: Enable + Switch + Reset */}
                <div className="flex items-center gap-4 shrink-0">


                  <NormalSwitch
                    name="automaticallySynchronizeOfflineData"
                    checked={formData.automaticallySynchronizeOfflineData}
                    // onChange={handleInputChange}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                    disabled={true}
                  />

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Automatically synchronize offline data"),
                        "automaticallySynchronizeOfflineData"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="flex items-center justify-between py-2 gap-6">
                {/* LEFT: Label + Tooltip */}
                <div className="flex items-center gap-2">
                  <p>
                    {getSettingTitle("Allow automatic peripheral enabling of new clients", "common.allow-automatic-peripheral-enabling-of-new-clients")}
                  </p>
                  <DefaultTooltip
                    title={getSettingTitle(
                      "Allow automatic peripheral enabling of new clients",
                      "common.allow-automatic-peripheral-enabling-of-new-clients"
                    )}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-21")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* RIGHT: Enable + Switch + Reset */}
                <div className="flex items-center gap-4 shrink-0">


                  <NormalSwitch
                    name="allowAutomaticPeripheralEnablingOfNewClient"
                    checked={formData.allowAutomaticPeripheralEnablingOfNewClient}
                    // onChange={handleInputChange}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                    disabled={true}
                  />

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Allow automatic peripheral enabling of new clients"),
                        "allowAutomaticPeripheralEnablingOfNewClient"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="flex items-center justify-between py-2 gap-6">
                {/* LEFT: Label + Tooltip */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Self enroll templates", "common.self-enroll-templates")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Self enroll templates", "common.self-enroll-templates")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-26")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* RIGHT: Enable + Switch + Reset */}
                <div className="flex items-center gap-4 shrink-0">


                  <NormalSwitch
                    disabled={true}
                    name="selfEnrollTemplates"
                    checked={formData.selfEnrollTemplates}
                    // onChange={handleInputChange}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                  />

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Self enroll templates"),
                        "selfEnrollTemplates"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="flex items-center justify-between py-2 gap-6">
                {/* LEFT: Label + Tooltip */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Guard application support", "common.guard-application-support")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Guard application support", "common.guard-application-support")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-29")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* RIGHT: Enable + Switch + Reset */}
                <div className="flex items-center gap-4 shrink-0">


                  <NormalSwitch
                    disabled={true}
                    name="guardApplicationSupport"
                    checked={formData.guardApplicationSupport}
                    // onChange={handleInputChange}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                  />

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Guard application support"),
                        "guardApplicationSupport"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="flex items-center justify-between py-2 gap-6">
                {/* LEFT: Label + Tooltip */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Hide user list on windows clients", "common.hide-user-list-on-client-apps")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Hide user list on windows clients", "common.hide-user-list-on-client-apps")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-30")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* RIGHT: Enable + Switch + Reset */}
                <div className="flex items-center gap-4 shrink-0">


                  <NormalSwitch
                    disabled={true}
                    name="hideUserListOnClientApps"
                    checked={formData.hideUserListOnClientApps}
                    // onChange={handleInputChange}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                  />

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Hide user list on windows clients"),
                        "hideUserListOnClientApps"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="flex items-center justify-between py-2 gap-6">
                {/* LEFT: Label + Tooltip */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Multi face mode", "common.Multi-face-mode")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Multi face mode", "common.Multi-face-mode")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-32")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* RIGHT: Enable + Switch + Reset */}
                <div className="flex items-center gap-4 shrink-0">


                  <NormalSwitch
                    disabled={true}
                    name="multiFaceMode"
                    checked={formData.multiFaceMode}
                    // onChange={handleInputChange}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                  />

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Multi face mode"),
                        "multiFaceMode"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>

              <div className="flex items-center justify-between py-2 gap-6">
                {/* LEFT: Label + Tooltip */}
                <div className="flex items-center gap-2">
                  <p>{getSettingTitle("Cancel event button on client event feedback ", "common.cancel-event-button-on-client-event-feedback")}</p>
                  <DefaultTooltip
                    title={getSettingTitle("Cancel event button on client event feedback ", "common.cancel-event-button-on-client-event-feedback")}
                    readMore={false}
                    content={
                      <div className="flex flex-col gap-3">
                        <p>{t("common.general-setting-question-31")}.</p>
                      </div>
                    }
                  >
                    <div>
                      <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                    </div>
                  </DefaultTooltip>
                </div>

                {/* RIGHT: Enable + Switch + Reset */}
                <div className="flex items-center gap-4 shrink-0">


                  <NormalSwitch
                    disabled={true}
                    name="cancelEventButtonOnClientEventFeedback"
                    checked={formData.cancelEventButtonOnClientEventFeedback}
                    // onChange={handleInputChange}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                  />

                  <CustomSecondaryButton
                    sx={{ pointerEvents: "none" }}
                    onClick={() =>
                      handleResetSetting(
                        getAttrTypeId("Cancel event button on client event feedback "),
                        "cancelEventButtonOnClientEventFeedback"
                      )
                    }
                  >
                    <RefreshCircleIcon20pxSvgV2></RefreshCircleIcon20pxSvgV2>
                  </CustomSecondaryButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {confirmResetAllOpen && (
        <ConfirmResetAllDialog
          onClose={handleCloseConfirmResetAll}
          onConfirm={handleResetAll}
        />
      )}
    </>
  );
};

export default ClientTab;
